export const whatTheySayContent = {
    title: "WHAT THEY SAY",

    sliderSettings: {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
    },

    testimonials: [
        {
            quote:
                "ARSH Industries has consistently delivered premium quality tipping paper and packaging materials. Their attention to detail, reliable service, and timely delivery make them a trusted partner for our brand’s global operations.",
            translation:
                "آرش انڈسٹریز ہمیشہ اعلیٰ معیار کا ٹیپنگ پیپر اور پیکیجنگ مواد فراہم کرتی ہے۔ ان کی باریک بینی، قابلِ اعتماد خدمت اور بروقت فراہمی نے انہیں ہمارے عالمی کاروبار کے لیے ایک قابلِ اعتماد شراکت دار بنا دیا ہے۔",
        },
        {
            quote:
                "Outstanding quality and innovation. ARSH delivers tipping paper that exceeds global standards.",
            translation:
                "جودة استثنائية وابتكار. تقدم أرش ورق التيبينج الذي يتجاوز المعايير العالمية.",
        },
        {
            quote:
                "Best partner for premium packaging. Their LIP and anti-counterfeit features are game-changers.",
            translation:
                "أفضل شريك للتغليف الفاخر. ميزات الحد من الاشتعال ومكافحة التزييف لديهم تغير قواعد اللعبة.",
        },
    ],
};